import { useContext } from 'react';
import AppContext from '../../AppContext';

function Artikelgallerie() {
  const { appData } = useContext(AppContext);

  const anzahlBilder = appData.static.artikel.bilder.length;
  const anzahlBilderStandard = 5;

  return (
    <div className="product-gallery">
      <div id="image_wrapper">
        <div className="row gallery-with-action-main">
          <div className="col product-detail-image-topbar">
            <button type="button" className="btn btn-link" id="image_fullscreen_close">
              <span aria-hidden="true"><i className="fa fa-times" /></span>
            </button>
          </div>
          <div className="col col-12">
            <div id="gallery_wrapper" className="clearfix">
              <div
                id="gallery"
                className="product-images slick-smooth-loading carousel slick-lazy"
                data-slick-type="gallery"
              >
                {appData.static.artikel.bilder.sort((a, b) => a.nNr - b.nNr).map((bild, index) => ((
                  <div
                    key={bild.nNr}
                    className={`square square-image js-gallery-images 
                          ${index !== 0 ? 'd-none' : ''}`}
                  >
                    <div className="inner">
                      <picture>
                        <source
                          srcSet={
                            `${bild.cURLMini.replaceAll('.jpg', '.webp')} ${bild.imageSizes.xs.size.width}w,
                                  ${bild.cURLKlein.replaceAll('.jpg', '.webp')} ${bild.imageSizes.sm.size.width}w,
                                  ${bild.cURLNormal.replaceAll('.jpg', '.webp')} ${bild.imageSizes.md.size.width}w,
                                  ${bild.cURLGross.replaceAll('.jpg', '.webp')} ${bild.imageSizes.lg.size.width}w`
                          }
                          type="image/webp"
                        />
                        <img
                          src={bild.cURLMini}
                          alt=""
                          style={{ maxHeight: '100%' }}
                          className="product-image img-fluid"
                          srcSet={
                            `${bild.cURLMini} ${bild.imageSizes.xs.size.width}w,
                                    ${bild.cURLKlein} ${bild.imageSizes.sm.size.width}w,
                                    ${bild.cURLNormal} ${bild.imageSizes.md.size.width}w,
                                    ${bild.cURLGross} ${bild.imageSizes.lg.size.width}w`
                          }
                          data-list={bild.galleryJSON}
                          data-index={index}
                          loading={index !== 0 ? 'lazy' : undefined}
                        />
                      </picture>
                    </div>
                  </div>
                )))}
              </div>
              {anzahlBilder > 1
                && (
                  <ul className="slick-dots initial-slick-dots d-lg-none" role="tablist">
                    {appData.static.artikel.bilder.map((bild, index) => ((
                      <li key={bild.nNr} className={`${index === 0 ? 'slick-active' : ''}`} role="presentation">
                        <button type="button">&nbsp;</button>
                      </li>
                    )))}
                  </ul>
                )}
            </div>
          </div>
          <div className="col product-detail-image-preview-bar col-12 align-self-end">
            <div id="gallery_preview_wrapper" className="product-thumbnails-wrapper">
              <div
                id="gallery_preview"
                className="product-thumbnails slick-smooth-loading carousel carousel-thumbnails slick-lazy slick-count-default"
                data-slick-type="gallery_preview"
              >
                {anzahlBilder > anzahlBilderStandard
                  && (
                    <button className="slick-prev slick-arrow slick-inital-arrow" aria-label="Previous" type="button">Previous</button>
                  )}
                {appData.static.artikel.bilder.sort((a, b) => a.nNr - b.nNr).map((bild, index) => ((
                  <div
                    key={bild.nNr}
                    className={`square square-image js-gallery-images
                          ${index === 0 ? 'preview-first' : ''} ${index === 0 && anzahlBilder <= anzahlBilderStandard ? 'first-ml' : ''}
                          ${index >= anzahlBilderStandard ? 'd-none' : ''}
                          ${index === anzahlBilder - 1 && anzahlBilder <= anzahlBilderStandard ? 'last-mr' : ''}`}
                  >
                    <div className="inner">
                      <picture>
                        <source
                          srcSet={`${bild.cURLKlein.replaceAll('.jpg', '.webp')}`}
                          type="image/webp"
                        />
                        <img src={bild.cURLKlein} alt="" className="product-image img-fluid" loading="lazy" />
                      </picture>
                    </div>
                  </div>
                )))}
                {anzahlBilder > anzahlBilderStandard
                  && (
                    <button className="slick-next slick-arrow slick-inital-arrow" aria-label="Next" type="button">Next</button>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Artikelgallerie;
